
import React from 'react';
import { DashboardProps } from '../types';
import { RpmIcon, PressureIcon, TimeIcon, TemperatureIcon, PhaseIcon } from './icons';

const DashboardCard: React.FC<{ icon: React.ReactNode; label: string; value: string | number; unit: string; }> = ({ icon, label, value, unit }) => (
  <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-3 flex flex-col items-center justify-center space-y-2 border border-slate-700 shadow-lg h-full">
    <div className="flex items-center space-x-3 text-cyan-400">
      {icon}
      <span className="text-base font-medium text-slate-300">{label}</span>
    </div>
    <div>
      <span className="text-3xl font-bold tracking-tighter text-white">{value}</span>
      <span className="text-base ml-2 text-slate-400">{unit}</span>
    </div>
  </div>
);

const Dashboard: React.FC<DashboardProps> = ({ rpm, pressure, openingTime, temperature, phase }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
      <DashboardCard 
        icon={<RpmIcon className="w-7 h-7"/>} 
        label="Motore" 
        value={rpm} 
        unit="RPM" 
      />
      <DashboardCard 
        icon={<PressureIcon className="w-7 h-7"/>} 
        label="Pressione" 
        value={pressure} 
        unit="bar" 
      />
       <DashboardCard 
        icon={<TemperatureIcon className="w-7 h-7"/>} 
        label="Temp." 
        value={temperature} 
        unit="°C" 
      />
      <DashboardCard 
        icon={<TimeIcon className="w-7 h-7"/>} 
        label="Apertura" 
        value={openingTime.toFixed(1)} 
        unit="ms" 
      />
      <DashboardCard 
        icon={<PhaseIcon className="w-7 h-7"/>} 
        label="Fase" 
        value={Math.round(phase)} 
        unit="°" 
      />
    </div>
  );
};

export default Dashboard;